// Configuration file with permission categories and the allowable permissions per permission catrgory

const PermissionCategoriesPermissionMapping = [
  {
    permissionCategoryId: "Dashboard",
    permissionCategoryName: "Dashboard",
    permissions: [{ id: "View", name: "View" }],
  },

  {
    permissionCategoryId: "MembershipApplication",
    permissionCategoryName: "Membership Application",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Create", name: "Update" },
    ],
  },

  {
    permissionCategoryId: "MembershipRequests",
    permissionCategoryName: "Membership Requests",
    permissions: [
      { id: "View", name: "View" },
      // { id: "Create", name: "Approve" },
      // { id: "Create", name: "Query" },
      // { id: "Create", name: "Reject" },
    ],
  },

  {
    permissionCategoryId: "MembershipApproval",
    permissionCategoryName: "Membership Approvals",
    permissions: [
      { id: "View", name: "View" },
      // { id: "Create", name: "Verify" },
      // { id: "Create", name: "Approve" },
      // { id: "Create", name: "Query" },
      // { id: "Create", name: "Reject" },
    ],
  },

  {
    permissionCategoryId: "AccessRequests",
    permissionCategoryName: "Access Requests",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Approve" },
      { id: "Update", name: "Reject" },
    ],
  },

  {
    permissionCategoryId: "ManageRole",
    permissionCategoryName: "Manage Role",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
    ],
  },
  {
    permissionCategoryId: "ManageUser",
    permissionCategoryName: "Manage User",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
    ],
  },

  {
    permissionCategoryId: "MasterList",
    permissionCategoryName: "Master List",
    permissions: [
      { id: "View", name: "View" },
      { id: "Update", name: "Update" },
    ],
  },

  {
    permissionCategoryId: "WorkflowManagement",
    permissionCategoryName: "Workflow Management",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
    ],
  },

  {
    permissionCategoryId: "MembershipTierManagement",
    permissionCategoryName: "Membership Tier",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
    ],
  },

  {
    permissionCategoryId: "AllPayments",
    permissionCategoryName: "All Payments",
    permissions: [
      { id: "View", name: "View" },
    ],
  },

  {
    permissionCategoryId: "MyPayments",
    permissionCategoryName: "My Payments",
    permissions: [
      { id: "View", name: "View" },
      { id: "View", name: "Pay" },
    ],
  },

  // Additional categories can be added here...
];

export default PermissionCategoriesPermissionMapping;
